import { Injectable } from '@angular/core';

@Injectable()
export class EcomTabsetConfig {
  /** provides default navigation context class: 'tabs' or 'pills' */
  public type = 'tabs';
}
